import React from 'react';
import './PageShell.css';

function AboutPage() {
  return (
    <div className="page-shell">
      <div className="page-shell-inner">
        <div className="about-logo">🍃</div>
        <h2>About hoja</h2>
        <p className="page-shell-subtitle">
          <em>hoja</em> — Spanish for leaf, a page of language you're working through.
        </p>
        <div className="about-content">
          <p>
            Hoja is a tool for language learners that makes web content comprehensible.
            When you encounter an unknown word while watching a French or German video,
            hoja surfaces rich, human-curated annotations right where you are —
            no tab switching, no picking up your phone.
          </p>
          <p>
            Hoja is currently in early access. More features coming soon.
          </p>
        </div>
      </div>
    </div>
  );
}

export default AboutPage;
